import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuSuppliers from '../submenu/SubmenuSuppliers'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SupplyOrderList from './SupplyOrderList'
import SupplyOrderOptions from './options/SupplyOrderOptions'
import SupplyOrdersFilters from './filters/SupplyOrdersFilters'

const SupplyOrders = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuSuppliers />
		</MyBlock>
		<MyBlockHeader
            header={'Заявки на постачання'}
            options={
                <SupplyOrderOptions />
            }
        />
		<MyBlock>
            <SupplyOrdersFilters />
        </MyBlock>
		<MyBlock>
			<SupplyOrderList />
		</MyBlock>
    </LayoutMain>
  )
}

export default SupplyOrders